<template>
  <ValidationProvider
    ref="validator"
    :name="formName"
    :rules="rules"
    :style="style.validationProvider"
  >
    <BaseInput
      v-bind="$attrs"
      v-on="$listeners"
      v-model="input"
      :errorMessage="(!disableValidator && errorOnDisplay) ? errorMessage : ''"
      @focus="errorOnDisplay = true;"
      @unfocus="errorOnDisplay = false;"
      :styleConfig="styleConfig"
    >
      <template v-slot:right="props">
        <GoogleMaterialIconPrimary
          v-if="filled && !props.disabled && props.focus"
          content="close"
          @mousedown="clearInput"
          :style="style.closeIcon"
        />
      </template>
      <template v-slot:error>
        <template v-if="errorOnDisplay">
          {{ errorMessage }}
        </template>
      </template>
    </BaseInput>
  </ValidationProvider>
</template>

<script>
  import BaseInput from '@base/v2/base-input'
  import GoogleMaterialIconPrimary
    from '@modules/v2/icon/google-material-icon-primary'
  import { ValidationProvider } from 'vee-validate'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  const FORM_HEIGHT = '32px';

  export default {
    name: 'InputPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change-input',
     },
    components: {
      BaseInput,
      GoogleMaterialIconPrimary,
      ValidationProvider,
    },
    props: {
      vmodelValue: {
        type: String,
        required: false,
        default: '',
      },
      disableValidator: {
        type: Boolean,
        required: false,
        default: false,
      },
      formName: {
        type: String,
        required: false,
        default: 'form',
      },
      rules: {
        type: [Object, String],
        required: false,
        default: null,
      },
    },
    data: function () {
      return {
        errorMessage: '',
        errorOnDisplay: false,
        input: this.vmodelValue,
        style: {
          closeIcon: {},
          validationProvider: {
            display: 'block',
          },
        },
        styleConfig: {
          container: {
            borderRadius: Layout.space.xs,
            height: 'fit-content',
          },
          dropdown: {},
          dropdownLeft: {},
          dropdownRight: {},
          error: {
            fontSize: FontStyle.size.xs,
            fontWeight: FontStyle.weight.sm,
            padding: `${Layout.space.sm}`,
            top: Layout.space.lg,
          },
          form: {
            alignItems: 'center',
            height: FORM_HEIGHT,
          },
          formPlaceholder: {
            height: FORM_HEIGHT,
          },
          input: {
            flex: 1,
            fontSize: FontStyle.size.md,
            fontWeight: {
              '': FontStyle.weight.lg,
              placeholder: FontStyle.weight.md,
            },
            padding: `0 ${Layout.space.sm} 0 ${Layout.space.md}`,
          },
          option: {},
          right: {
            margin: `0 ${Layout.space.sm} 0 0`,
          },
          row: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.container,
        {
          backgroundColor: this.color.shadow1(),
          border: {
            '': `solid ${this.color.dark5()}`,
            hover: `solid ${this.color.dark2()}`,
            active: `solid ${this.color.action1()}`,
            disabled: 'none',
            error: `solid ${this.color.warning1()}`,
          },
          borderWidth: {
            '': '1px',
            disabled: 'none',
          },
        },
      );
      Object.assign(
        this.styleConfig.error,
        {
          color: this.color.warning1(),
        },
      );
      Object.assign(
        this.styleConfig.input,
        {
          color: {
            '': this.color.dark2(),
            disabled: this.color.dark3(),
            placeholder: this.color.dark4(),
          },
        },
      );
    },
    mounted: function () {
      this.$watch(
        () => this.$refs.validator.errors,
        (newErrors, oldErrors) => {
          this.errorMessage = newErrors.length > 0 ? newErrors[0] : '';
        },
      );

      this.$refs.validator.validate(this.vmodelValue);
    },
    methods: {
      clearInput: function () {
        this.input = '';
      },
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      filled: function () {
        return this.input.length > 0;
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.input = newVal;
      },
    },
  };
</script>
